// Import your translation files
import { initReactI18next } from "react-i18next";
import i18next from "i18next";
import { en } from "./en";
import { hi } from "./hi";

const language = localStorage.getItem("language")
i18next.use(initReactI18next).init({
  resources: {
    en,
    hi
  },
  lng: language, // Default language
  fallbackLng: "en", // Fallback language
  interpolation: {
    escapeValue: false,
  },
});
const I18nInitializer = ({ children }) => {
  return <>{children}</>;
};

export default I18nInitializer;
